/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_ppt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M0 0h20v20H0V0zm7 14.842c0 .095.066.158.165.158H8.42c.099 0 .165-.063.165-.158v-3.963h2.674c1.503 0 2.741-1.141 2.741-2.916S12.762 5 11.26 5H7.164C7.066 5 7 5.063 7 5.158v9.684zm4.094-5.358h-2.51v-3.01h2.51c.71 0 1.321.46 1.321 1.505 0 1.014-.61 1.505-1.32 1.505z" _fill="#D14424"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_ppt.js